import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Dashboard from "./pages/Dashboard";
import DashboardAdmin from "./pages/DashboardAdmin";

// Solution Pages
import BrokerageSolutions from "./solutionspage/BrokerageSolutionsPage";
import AgentsSolutions from "./solutionspage/AgentsSolutionsPage";
import VendorSolutions from "./solutionspage/VendorSolutionsPage";

// Feature Pages
import InstallationFeature from "./featurespage/InstallationFeaturePage";
import RemovalFeature from "./featurespage/RemovalFeaturePage";
import VendorMarketplace from "./featurespage/VendorMarketPlaceFeaturePage";
import WorkDrive from "./featurespage/WorkDriveFeaturePage";
import SmartRead from "./featurespage/SmartReadFeaturePage";
import ReportingFeature from "./featurespage/ReportingFeaturePage";

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const isDashboardAdmin = location.pathname === "/dashboard/admin";
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header at the top - hidden on dashboard */}
      {!isDashboard && !isDashboardAdmin && <Header />}

      {/* Main content area - routes render here between Header and Footer */}
      <main className={isDashboard || isDashboardAdmin ? "" : "flex-grow"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/admin" element={<DashboardAdmin />} />
          <Route path="/solutions/brokerages" element={<BrokerageSolutions />} />
          <Route path="/solutions/agents" element={<AgentsSolutions />} />
          <Route path="/solutions/vendors" element={<VendorSolutions />} />
          <Route path="/features/installations" element={<InstallationFeature />} />
          <Route path="/features/removals" element={<RemovalFeature />} />
          <Route path="/features/vendormarketplace" element={<VendorMarketplace />} />
          <Route path="/features/workdrive" element={<WorkDrive />} />
          <Route path="/features/smartread" element={<SmartRead />} />
          <Route path="/features/reporting" element={<ReportingFeature />} />
        </Routes>
      </main>

      {/* Footer at the bottom - hidden on dashboard */}
      {!isDashboard && !isDashboardAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
